import api from './api';
import { AuthResponse } from '../types';

export const authService = {
  login: async (email: string, password: string, rememberToken?: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', {
      email,
      password,
      rememberToken
    });
    return response.data;
  },

  loginWithLicense: async (email: string, licenseKey: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login/license', { email, licenseKey });
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  verifyToken: async () => {
    const response = await api.post('/auth/verify');
    return response.data;
  },

  verifyInvite: async (token: string) => {
    const response = await api.get('/auth/invite/verify', { params: { token } });
    return response.data;
  },

  acceptInvite: async (token: string, password: string) => {
    const response = await api.post('/auth/invite/accept', { token, password });
    return response.data;
  },

  requestPasswordReset: async (email: string) => {
    const response = await api.post('/auth/password/forgot', { email });
    return response.data;
  },

  resetPassword: async (token: string, password: string) => {
    const response = await api.post('/auth/password/reset', { token, password });
    return response.data;
  },

  verifyMfaCode: async (
    mfaToken: string,
    code: string,
    rememberDevice: boolean
  ): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/mfa/verify', {
      mfaToken,
      code,
      rememberDevice
    });
    return response.data;
  },

  updateMfaSettings: async (enabled: boolean) => {
    const response = await api.post('/auth/mfa/settings', { enabled });
    return response.data;
  },

  updateIntegrations: async (
    jiraOrgUrl: string,
    jiraUsername: string,
    jiraAccessToken: string,
    confluenceOrgUrl: string,
    confluenceUsername: string,
    confluenceAccessToken: string
  ) => {
    const response = await api.post('/auth/profile/integrations', {
      jira: {
        jiraOrgUrl,
        jiraUsername,
        jiraAccessToken
      },
      confluence: {
        confluenceOrgUrl,
        confluenceUsername,
        confluenceAccessToken
      }
    });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};
